import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import LoadingSpinner from "../../Components/Common/LoadingSpinner";
import About from '../About';
import WhatIs from '../WhatIs';
import CorporateSolutions from '../CorporateSolutions';
import BrandDigitalCard from '../BrandDigitalCard';
import ContactPage from '../Contact';
import NPO from '../NPO';
import LandingPage from '../LandingPage';
import DynamicPage from '../DynamicPage';
import TopCharities from '../TopCharities';
import ShoppingCart from '../ShoppingCart';
import CreditCheckout from '../CreditCheckout';
import OrderComplete from '../OrderComplete';
import PayPalCheckout from '../PayPalCheckout';
import CorporateCheckCheckout from '../CorporateCheckCheckout';
import Covid19 from '../Covid19';
import Support from '../Support';


export default class Main extends Component {
  componentDidMount() {
  }
  render() {
    return (
      <Switch>
        <Route exact key='home' path='/' render={(props) => <LandingPage {...props} />} />
        <Route exact path='/About' component={About} />
        <Route exact path='/WhatIs' component={WhatIs} />
        <Route exact path='/CorporateSolutions' component={CorporateSolutions} />
        <Route exact path='/CorporateSolutions/BrandDigitalCard' render={() => <BrandDigitalCard {...this.props} />} />
        <Route exact path='/NPO' component={NPO} />
        <Route exact path='/Contact' render={() => <ContactPage {...this.props} />} />
        <Route exact path='/DynamicPage' component={DynamicPage} />
        <Route exact path='/Purchase/ShoppingCart' component={() => ( this.props.isLoading ? <LoadingSpinner /> : <ShoppingCart {...this.props} />)} />
        <Route exact path='/Purchase/CreditCheckout' component={() => ( this.props.isLoading ? <LoadingSpinner /> : <CreditCheckout {...this.props} />)} />
        <Route exact path='/Purchase/PayPalCheckout' component={ ({location}) => ( this.props.isLoading ? <LoadingSpinner /> : <PayPalCheckout location={location} {...this.props} />)} />
        <Route exact path='/Purchase/CorporateCheckCheckout' component={ ({location}) => ( this.props.isLoading ? <LoadingSpinner /> : <CorporateCheckCheckout location={location} {...this.props} />)} />
        <Route exact path='/Purchase/OrderComplete' component={({location}) => ( this.props.isLoading ? <LoadingSpinner /> : <OrderComplete location={location} {...this.props} />)} />
        <Route exact path='/TopCharities' component={TopCharities} />
        <Route exact path='/Covid19' component={Covid19} />
        <Route path='/Support/:charityIdOrName' component={Support} />
      </Switch>
    );
  }
}
